{
  "delete": "Delete",
  "comment": "Comment",
  "order": "Order",
  "upload_date": "Upload date",
  "add_moodboard": "Add moodboard",
  "tags": "Tags",
  "download": "Download",
  "moodboard_submit": "Submit moodboard",
  "image_not_found": "Image not found",
  "title": "Title",
  "audio_file": "audio file",
  "field_required": "This field is required",
  "open_on_tab": "Open on new tab",
  "delete_moodboard": "Delete moodboard",

  "error_left": "An error has occurred while displaying moodboard",
  "error_right": "An error has occurred while displaying comments drawer"
}
